import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core'

import { JsonLdLoaderService } from './json-ld-loader.service'

export function provideJsonLd(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const initializerFn = (() => inject(JsonLdLoaderService).load)()
      return initializerFn()
    }),
  ])
}
